import fetch from '@/plugin/axios'

// 获取动画场景列表
export function getAnimFlowList (data) {
  return fetch({
    url: '/api/common/bot-anim-flow/list',
    method: 'Post',
    data: data
  })
}

// 获取动画场景详情
export function getAnimFlowDetail (id) {
  return fetch({
    url: `/api/common/bot-anim-flow/info/${id}`,
    method: 'Get'
  })
}

// 新增动画场景
export function addAnimFlow (data) {
  return fetch({
    url: '/api/common/bot-anim-flow/add',
    method: 'Post',
    data: data
  })
}

// 修改动画场景
export function updateAnimFlow (id, data) {
  return fetch({
    url: `/api/common/bot-anim-flow/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 删除动画场景
export function deleteAnimFlow (id) {
  return fetch({
    url: `/api/common/bot-anim-flow/${id}`,
    method: 'Delete'
  })
}

// 获取动画场景选项
export function getAnimFlowOptions () {
  return fetch({
    url: '/api/common/bot-anim-flow/options',
    method: 'Get'
  })
}
